class FavoriteButton extends HTMLElement {
    static #_wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

    static get wishlist() {
        return this.#_wishlist;
    }

    static set wishlist(value) {
        this.#_wishlist = value;
        localStorage.setItem('wishlist', JSON.stringify(this.#_wishlist));
    }

    constructor() {
        super();
    }

    connectedCallback() {
        this.role = 'button';
        this.productHandle = this.dataset.productHandle;

        this.isActive = FavoriteButton.wishlist.includes(this.productHandle);

        this.isActive && this.classList.add('active');

        this.addEventListener('click', this.handleClick.bind(this));
        window.priceFromDolar();
    }

    handleClick() {
        this.toggleActive();

        if (this.isActive) {
            FavoriteButton.wishlist = [...FavoriteButton.wishlist, this.productHandle];
        } else {
            FavoriteButton.wishlist = FavoriteButton.wishlist.filter((productHandle) => productHandle !== this.productHandle);
        }
    }

    toggleActive() {
        this.isActive = !this.isActive;
        this.classList.toggle('active');
    }
}

if (!customElements.get('favorite-button')) {
    customElements.define('favorite-button', FavoriteButton);
}
